// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-base-container .left-container {
  background-repeat: no-repeat;
  background-position: bottom right;
}
.auth-base-container .right-container {
  background-size: cover !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/auth/components/auth-base/auth-base.component.scss"],"names":[],"mappings":"AACC;EACC,4BAAA;EACA,iCAAA;AAAF;AAGC;EACC,iCAAA;AADF","sourcesContent":[".auth-base-container {\n\t.left-container {\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: bottom right;\n\t}\n\n\t.right-container {\n\t\tbackground-size: cover !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
